import ClaimInformation from './ClaimInformation.component';

export default ClaimInformation;
